import { useTranslation } from 'react-i18next';
import { BasicScreenProps, VendingMachine } from '../../../types';
import PrimaryButton from '../../common/PrimaryButton';
import ScreenTitle from '../../common/ScreenTitle';
import ScreenWrapper from '../../common/ScreenWrapper';
import { useRecoilValue } from 'recoil';
import { vmState } from '../../../state/recoilState';
import { MACHINE_TYPES } from '../../../constants';
import SVGObject from '../../common/SVGObject';

interface CompletePage extends BasicScreenProps {
  onRepeatPurchase?: () => void;
}

const CompletePage = (props: CompletePage) => {
  const { onRepeatPurchase } = props;
  const { t } = useTranslation();
  const vm = useRecoilValue<VendingMachine>(vmState);
  const isFridge = vm.type_id === MACHINE_TYPES.FRIDGE;

  return (
    <ScreenWrapper>
      <ScreenWrapper>
        <ScreenTitle>{t('Please make a selection with the machine to receive a present. Thank you for your feedback and have a great day!')} </ScreenTitle>
        {/* <object data="/tick.html" /> */}
        <SVGObject className='food' src='/food_choice.html' />
      </ScreenWrapper>
    </ScreenWrapper>
  );
};

export default CompletePage;